import { createApp } from 'vue';
import App from './App.vue';
import './assets/styles/base.css';
import './assets/styles/tailwind.css';
import './assets/styles/padding.css';
import './assets/styles/margin.css';
import './assets/styles/font.css';
import './assets/styles/width.css';
import './assets/styles/ziti.css';
import addPlugin from './plugins/vue/addPlugin';

import {
  Picker,
  Popup,
} from '@nutui/nutui';
import '@nutui/nutui/dist/style.css';
import { useStore, useData } from './store';
// 日志记录脚本
import DataReporter from './utils/DataReporter';
const reporter = new DataReporter();

const app = createApp(App);
app.use(addPlugin);
app.use(Picker);
app.use(Popup);
app.provide('GlobalStore', useStore());
app.provide('GlobalData', useData());
app.provide('GlobalReporter', reporter);
app.mount('#app');

console.log('当前变量', import.meta.env,window.location.href);
